import { render } from "./OrganizersDescriptionWebEditing.vue?vue&type=template&id=3087d1fa&ts=true"
import script from "./OrganizersDescriptionWebEditing.vue?vue&type=script&lang=ts"
export * from "./OrganizersDescriptionWebEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__